module.exports = __webpack_public_path__ + "static/img/ku-csp.046a489.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ku-csp.jpg
// module id = Tlhc
// module chunks = 0